import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const useAgentIdParam = () => {
  const { agentId } = useParams();

  const [id, setId] = useState<string | undefined>(agentId);

  useEffect(() => {
    if (agentId === id) return;
    setId(agentId);
  }, [agentId]);

  return id;
};

export default useAgentIdParam;
